import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import type { SearchBarButtonProps } from '@uncinc/react-searchkit/dist/components/SearchBar/Base';
import type { SearchResetButtonProps } from '@uncinc/react-searchkit/dist/components/Reset';

import ButtonWrapper from '../../ButtonWrapper';

import './style.scss';

const SearchBarButton = (buttonProps: SearchBarButtonProps) => (
  <ButtonWrapper
    {...buttonProps}
    iconName="search"
  />
);
const ResetButton = (buttonProps: SearchResetButtonProps) => {
  const { t } = useTranslation();

  return (
    <ButtonWrapper
      {...buttonProps}
      iconName="close"
      type="textual"
      variant="icon-only"
      aria-label={t('searchkit.buttons.reset')}
    />
  );
};

const SearchAllContentSearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>((props, ref) => {
  const { t } = useTranslation();
  const { className, placeholder = t('pages.search.searchbar_placeholder'), ...restProps } = props;

  const classNames = c('SearchAllContent__SearchBar', className);

  return (
    <SearchBar
      {...restProps}
      ref={ref}
      className={classNames}
      button={SearchBarButton}
      placeholder={placeholder}
      showReset
      ariaLabel={t('searchkit.search_bar.aria_label')}
      resetProps={{ button: ResetButton }}
    />
  );
});

export default SearchAllContentSearchBar;
